"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLearnerContext = void 0;
var react_1 = require("react");
var LearnerContext_1 = require("../contexts/LearnerContext");
//This custom hook is responsible for consuming the learner context.
function useLearnerContext() {
    var context = (0, react_1.useContext)(LearnerContext_1.LearnerContext);
    if (!context) {
        throw new Error('The useLearnerContext must be used within an LearnerProvider.');
    }
    return context;
}
exports.useLearnerContext = useLearnerContext;
//# sourceMappingURL=useLearnerContext.js.map